import * as React from 'react';
import {
    FacebookShareButton,
    FacebookIcon,
    PinterestShareButton,
    PinterestIcon,
    RedditShareButton,
    RedditIcon,
    TwitterShareButton,

    TwitterIcon
} from "react-share";
import shareIcon from 'images/share_red.svg';
import closeIcon from 'images/ico_close_cross_red.svg';
import isBrowser from '../../services/isBrowser';
import { useEffect, useState } from 'react';

export const ShareButton = () => {
    const [initialized, setInitialized] = useState(false);
    useEffect(() => {
        if (isBrowser()) {
            setTimeout(() => {
                setInitialized(true);
            }, 100)
        }
    }, [])
    const [shareContentActive, setShareContentActive] = React.useState<boolean>(false);
    return (<>
        {initialized && <><button onClick={() => { setShareContentActive(!shareContentActive) }} className='z-[1000] bg-white mdmax:hidden fixed rounded-full shadow-standard w-[50px] h-[50px] bottom-[40px] right-[40px]'>
            {!shareContentActive && <img src={shareIcon} className="w-[60%] relative left-[15%]" />}
            {shareContentActive && <img src={closeIcon} className="w-[50%] relative left-[25%]" />}
        </button>
            <ShareContent active={shareContentActive} /></>}
    </>)

}

export const ShareContent = ({ active, partOfPage }: { active: boolean, partOfPage?: boolean }) => {
    const pathWithSearch = isBrowser() ? `${window.location.pathname}${window.location.search}` : "/";
    const completeUrl = `https://sunheron.com${pathWithSearch}`;
    return (
        <div onClick={(e) => { e.stopPropagation(); }} className={`${active ? ' opacity-1 pointer-events-auto' : 'pointer-events-none opacity-0'} justify-center gap-[20px] flex ${partOfPage && 'm-auto'} ${!partOfPage && 'z-[1000] bg-white rounded-full duration-300 shadow-standard mdmax:hidden w-[300px] h-[50px] bottom-[40px] right-[120px] transition-opacity fixed'}`}>
            <FacebookShareButton url={completeUrl}><FacebookIcon size={40} round={true} /></FacebookShareButton>
            <TwitterShareButton url={completeUrl}><TwitterIcon size={40} round={true} /></TwitterShareButton>
            <RedditShareButton url={completeUrl}><RedditIcon size={40} round={true} /></RedditShareButton>
            <PinterestShareButton media="https://sunheron.com/sunheron-og.png" url={completeUrl}><PinterestIcon size={40} round={true} /></PinterestShareButton>
        </div >)
}